var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 82,
    viewBox: "0 0 90 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.3751 23.0613V1L35.7489 2.46334L37.0376 5.77715L36.6694 10.5177L31.4685 25.4298L24.0585 31.8273L21.6652 30.4466L19.6861 31.8734L19.8242 33.8985L17.8911 33.6683L15.6359 37.6265L16.2803 41.0323L13.979 42.5051L11.9539 39.8357L10.4351 40.0198L7.99576 45.1746L8.91626 48.5804L6.84513 49.7311L5.87861 53.0909L0.99995 53.4591L1 59.6725L6.61505 70.3503L11.954 73.7561L14.5314 79.2792L20.3766 81.1202L23.8746 78.6348L25.9457 80.1536L31.9289 78.4047L32.1131 75.7813L34.0921 77.3001L42.2385 74.1704L43.113 69.5679L48.9582 61.2834L54.2511 49.7311L60.6946 53.229L65.8034 43.3796L68.5649 45.1746L76.8494 35.4633L77.6318 29.434L87.0669 36.3838L89 32.3336L88.2636 31.8734L88.3096 29.5721L86.9749 28.7437L86.6988 26.4424L83.7071 25.66L81.682 24.4173L79.6109 25.0616L76.7113 25.66L75.9749 27.9612L72.9373 27.593L70.4519 25.798L67.0921 29.8022L64.8829 28.6516L62.0293 31.9194L57.1645 34.7463V23.0613H38.3751Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWv);
export default __webpack_public_path__ + "static/media/WV.f80e960789f9ef995dc49fbebc04d4a1.svg";
export { ForwardRef as ReactComponent };